import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './BulletList.module.scss'
import { BulletListProps } from './types'

const BulletList: React.FC<BulletListProps> = forwardRef(
  ({ className, items, size = 'default', testId, ...props }, ref) => (
    <ul className={cn(styles.list, className)} data-testid={testId} ref={ref} {...props}>
      {items.map((item) => (
        <li key={item?.toString()} className={cn(styles.listItem, styles[`listItem_${size}`])}>
          {item}
        </li>
      ))}
    </ul>
  ),
)
export default BulletList
